import { IContract } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { Link } from "@rentiohq/web-shared-next/dist/ui-components";
import { getContractLabel, getContractRoute } from "../../Payments.utils";

interface IContractDurationLinkProps {
  contract: IContract;
}

export const ContractDurationLink = ({
  contract,
}: IContractDurationLinkProps) => (
  <Link
    link={getContractRoute(contract)}
    label={getContractLabel(contract)}
    underlined={false}
  />
);
